import type { FieldMod } from "../meta/field-mods";

// Post-mission field-mod draft: pick 1 of 3 (or skip for a trickle of ops).
// Pure renderer; the flow supplies the choices and consumes the pick.

const RARITY_LABEL: Record<FieldMod["rarity"], string> = {
  common: "FIELD",
  rare: "REQUISITION",
  epic: "COMMAND",
};

export class ModDraftScreen {
  private readonly el: HTMLElement;
  private choices: FieldMod[] = [];
  private onPick: ((modId: string | null) => void) | null = null;

  constructor() {
    this.el = document.createElement("div");
    this.el.id = "mod-draft";
    this.el.className = "screen-overlay";
    this.el.style.zIndex = "360";
    document.body.appendChild(this.el);
    this.el.addEventListener("click", this.handleClick);
  }

  show(choices: FieldMod[], onPick: (modId: string | null) => void): void {
    this.choices = choices;
    this.onPick = onPick;
    this.render();
    this.el.classList.add("is-visible");
  }

  private render(): void {
    const cards = this.choices.map((mod) => `
      <div class="draft-card draft-card--${mod.rarity}" data-pick="${mod.id}">
        <div class="draft-card__rarity">${RARITY_LABEL[mod.rarity]}</div>
        <div class="draft-card__name">${mod.name}</div>
        <div class="draft-card__desc">${mod.desc}</div>
        <button class="screen-button screen-button--small" data-pick="${mod.id}">TAKE</button>
      </div>`).join("");

    this.el.innerHTML = `
      <div class="screen-kicker">RESUPPLY DROP</div>
      <div class="screen-title screen-title--compact">DRAFT A FIELD MOD</div>
      <div class="draft-row">${cards}</div>
      <div class="screen-actions" style="margin-top:16px">
        <button id="draft-skip" class="screen-button screen-button--muted screen-button--small">DECLINE (+1 OPS)</button>
      </div>
    `;
  }

  hide(): void {
    this.el.classList.remove("is-visible");
  }

  private handleClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement | null;
    if (!target) return;
    if (target.closest("#draft-skip")) {
      this.hide();
      this.onPick?.(null);
      return;
    }
    const modId = target.closest<HTMLElement>("[data-pick]")?.dataset["pick"];
    if (!modId) return;
    this.hide();
    this.onPick?.(modId);
  };
}
